import { useMemo, useState, FC } from "react";
import { Box, ClickAwayListener } from "@mui/material";
import { DropdownArrPropsType, MultiDropDataType } from "DataTypes/Form";
import MultiSelectDrop from "./Box";
import ControlledForm from "Components/ControlledForm";
const MultiSelectDropDown: FC<MultiDropDataType> = (
  props: MultiDropDataType
) => {
  const [openDrop, setOpenDrop] = useState(false);

  const {
    id,
    label,
    placeholder,
    dropArr,
    dropValue,
    required,
    onClick,
    width,
    error,
    errorText,
    disableSelectAll,
    disableArr,
    readOnly,
    maxLength,
    dropListHeight,
  } = props;
  const handleClick = (): void => {
    setOpenDrop(openDrop ? false : true);
  };

  // Derived directly from props (not synced local state) so a selection
  // click can't race the round-tripped `dropValue` prop update and cause
  // a runaway re-render loop under fast/rapid clicking.
  const selectedItems: DropdownArrPropsType[] = useMemo(() => {
    const newArr: DropdownArrPropsType[] = [];
    dropValue?.forEach((el) => {
      const newObj = dropArr?.find((el1) => el1.value == el);
      newObj && newArr.push(newObj);
    });
    return newArr;
  }, [dropValue, dropArr]);

  const inputValue = useMemo(
    () => selectedItems.map((el) => el.label).join(", "),
    [selectedItems]
  );

  const allSelectCheck = useMemo(() => {
    if (!dropArr || dropArr.length === 0) return false;
    return dropArr.every((el) =>
      selectedItems.some((selectedEl) => selectedEl.id == el.id)
    );
  }, [dropArr, selectedItems]);

  const handleSelect = (obj: DropdownArrPropsType): void => {
    const found = selectedItems.find(
      (el: DropdownArrPropsType) => el.id == obj.id
    );
    const newArr = found
      ? selectedItems.filter((el) => el.id !== obj.id)
      : [...selectedItems, obj];
    onClick && onClick(newArr.map((el) => el.value) || []);
  };

  const handleSelectAll = (): void => {
    if (allSelectCheck) {
      onClick && onClick([]);
    } else {
      const newArr = structuredClone(dropArr);
      onClick && onClick(newArr.map((el) => el.value) || []);
    }
  };

  return (
    <ClickAwayListener onClickAway={() => setOpenDrop(false)}>
      <Box sx={{ ...sxDrop }} width={width ? width : "100%"}>
        <ControlledForm.Input
          readOnly={readOnly}
          id={id}
          {...(label && { label: label })}
          {...(placeholder && { placeholder: placeholder })}
          {...(required && { required: required })}
          value={inputValue}
          iconClickHandler={() => handleClick()}
          iconId={openDrop ? "dropup" : "dropdown"}
          error={error ? error : false}
          errorText={errorText}
          required={required}
        />
        {openDrop && (
          <MultiSelectDrop
            {...(!disableSelectAll && { handleSelectAll: handleSelectAll })}
            allSelectCheck={allSelectCheck}
            dropArr={dropArr ? dropArr : []}
            selectedItems={selectedItems}
            handleSelect={(el) => handleSelect(el)}
            disableItems={disableArr || []}
            maxLength={maxLength || null}
            dropListHeight={dropListHeight}
          />
        )}
      </Box>
    </ClickAwayListener>
  );
};
export default MultiSelectDropDown;

const sxDrop = {
  position: "relative",
  cursor: "pointer",
};
